export default __webpack_public_path__ + "static/media/landing.0a955373.png";